export enum ScanResultType {
  NESSUS = 'NESSUS',
  HORIZON = 'HORIZON',
  BREACH_LENSE = 'BREACH_LENSE',
  IDENTECO = 'IDENTECO',
}

export namespace ScanResultType {
  export function mapFromApiValue(type: string): ScanResultType {
    const types: Record<string, ScanResultType> = {
      ['NESSUS']: ScanResultType.NESSUS,
      ['HORIZON']: ScanResultType.HORIZON,
      ['BREACH_LENSE']: ScanResultType.BREACH_LENSE,
      ['IDENTECO']: ScanResultType.IDENTECO,
    };
    return types[type];
  }
}
